export enum EditPipelineStepGroups {
  PIPELINE_CONFIGURATION = 'pipeline-config',
  OBJECT_CONFIGURATION = 'object-config',
  REVIEW = 'review'
}

export enum EditPipelineStepPaths {
  PIPELINE_SETTINGS = 'pipeline-config/pipeline-settings',
  CONFIGURE_OBJECTS = 'object-config/objects-settings',
  REVIEW = 'review/review-configuration'
}
